import styled from 'styled-components';

export const Title = styled.h2`
  font-weight: 700;
  line-height: 28.5px;
  font-family: 'Inter', sans-serif;
  color: #1e242f;
  margin: 0;
  text-align: center;
`;
